import { render, staticRenderFns } from "./BASchoolAdminDashboard.vue?vue&type=template&id=3ccc9941&scoped=true&"
import script from "./BASchoolAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./BASchoolAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccc9941",
  null
  
)

export default component.exports